export const CSV = "[csv]";
export const UPLOAD_CUSTOMER_CSV = `${CSV} UPLOAD_CUSTOMER_CSV`;

export const uploadCustomerCsv = (csvFile) => ({
    type: UPLOAD_CUSTOMER_CSV,
    payload: {
        data: csvFile
    }
});

